'use client';

import { useEffect, useRef } from 'react';

import type { SearchListingsRequest, SearchListingsResult } from '@/src/lib/api';
import { getSrpPageViewRequestKey, useSrpPageViewCoordinator } from './SrpPageViewCoordinator';

type SrpLiveSearchPageViewState = {
  initialRequest: SearchListingsRequest;
  request: SearchListingsRequest;
  data: SearchListingsResult | undefined;
  isPlaceholderData: boolean;
  isError: boolean;
  fetchStatus: 'fetching' | 'paused' | 'idle';
  isAgentic: boolean;
};

export function useSrpLiveSearchPageView({
  initialRequest,
  request,
  data,
  isPlaceholderData,
  isError,
  fetchStatus,
  isAgentic,
}: SrpLiveSearchPageViewState): string {
  const { trackLiveSearch } = useSrpPageViewCoordinator();
  const requestKey = getSrpPageViewRequestKey(request);
  const lastEmittedRequestKeyRef = useRef(getSrpPageViewRequestKey(initialRequest));

  useEffect(() => {
    if (data === undefined || isPlaceholderData || isError || fetchStatus !== 'idle') return;
    if (requestKey === lastEmittedRequestKeyRef.current) return;

    lastEmittedRequestKeyRef.current = requestKey;
    trackLiveSearch(requestKey, isAgentic);
  }, [data, fetchStatus, isAgentic, isError, isPlaceholderData, requestKey, trackLiveSearch]);

  return requestKey;
}
